<script setup lang="ts">
import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import {emitter} from "@/router";
import {reloadOutline} from "ionicons/icons";

const onResolveTest = () => {
  console.debug("Emitter: event-DeleteAllProgress");
  emitter.emit('event-DeleteAllProgress', {});
};

</script>

<template>
  <ion-menu side="end" menu-id="topic-menu" content-id="main-content" :swipe-gesture="false">
    <ion-header>
      <ion-toolbar>
        <ion-title></ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="content-menu">
      <ion-list>
        <ion-menu-toggle menu="topic-menu">
          <ion-item button @click="onResolveTest">
            <ion-icon color="danger" aria-hidden="true" slot="start" :icon="reloadOutline"></ion-icon>
            <ion-label color="danger">Borrar progreso</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>

    </ion-content>
  </ion-menu>
</template>

<style scoped>

.content-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>